import { Form, Input, Radio } from "antd";
import React from "react";

const ChooseCar = () => {
  return (
    <div className="container ">
      <Form
        name="basic"
        // initialValues={{
        //   remember: true,
        // }}
        // onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="py-[70px] surveyForm"
      >
        <Form.Item
          label="Is the car drivable?"
          className="bg-[#D9D9D947] border-[0.5px] border-[#575757] py-4 rounded-xl pl-4 mb-[50px]"
        >
          <Radio.Group className="flex justify-end">
            <Radio value="yes"> Yes </Radio>
            <Radio value="no"> No </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Are all four tires available,"
          className="bg-[#D9D9D947] border-[0.5px] border-[#575757] mb-[50px] py-4 rounded-xl pl-4"
        >
          <Radio.Group className="flex justify-end">
            <Radio value="yes"> Yes </Radio>
            <Radio value="no"> No </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Has the car been involved in any accidents?"
          className="bg-[#D9D9D947] border-[0.5px] border-[#575757] mb-[50px] py-4 rounded-xl pl-4"
        >
          <Radio.Group className="flex justify-end">
            <Radio value="yes"> Yes </Radio>
            <Radio value="no"> No </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Are there any mechanical issues on the dashboard?"
          className="bg-[#D9D9D947] border-[0.5px] border-[#575757] mb-[50px] py-4 rounded-xl pl-4"
        >
          <Radio.Group className="flex justify-end">
            <Radio value="yes"> Yes </Radio>
            <Radio value="no"> No </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Can I take the car for a test drive?"
          className="bg-[#D9D9D947] border-[0.5px] border-[#575757] mb-[50px] py-4 rounded-xl pl-4"
        >
          <Radio.Group className="flex justify-end">
            <Radio value="yes"> Yes </Radio>
            <Radio value="no"> No </Radio>
          </Radio.Group>
        </Form.Item>

        <div className="mb-[50px]">
          <p className="text-xl pb-5">
            If so, what was the extent of the damage, and has it been repaired?
          </p>
          <Input className="py-5 rounded-xl bg-[#D9D9D947] border-[0.5px] border-[#575757]" />
        </div>

        <div className="mb-[50px]">
          <p className="text-xl pb-5">
            What is the overall condition of the exterior and interior of the
            car?
          </p>
          <Input className="py-5 rounded-xl bg-[#D9D9D947] border-[0.5px] border-[#575757]" />
        </div>

        <div className="mb-[50px]">
          <p className="text-xl pb-5">
            What is the fuel efficiency of the car?
          </p>
          <Input className="py-5 rounded-xl bg-[#D9D9D947] border-[0.5px] border-[#575757]" />
        </div>

        <div className="w-full flex justify-center">
          <button
            htmlType="submit"
            className="darkBlue text-white py-6 text-lg min-w-[223px]"
          >
            Submit
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ChooseCar;
